module.exports = __webpack_public_path__ + "static/media/warning-icon.f921c00c.svg";